var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filters"},_vm._l((_vm.labels),function(label,index){return _c('span',{key:`${label.text}_${index}`,staticClass:"filter",class:{ active: _vm.activeIndex === index },on:{"click":function($event){return _vm.tabClicked(index)}}},[_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t(label.text))))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }